import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SearchPlusFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.2 3.4C14.14 3.4 17.4 6.64 17.4 10.56C17.4 12.3 16.76 13.92 15.7 15.18L20 19.48L18.68 20.8L14.32 16.44C13.14 17.26 11.72 17.74 10.2 17.74C6.26 17.74 3 14.48 3 10.56C3 6.64 6.26 3.4 10.2 3.4ZM13.54 11.36V9.8H10.98V7.24H9.42V9.8H6.86V11.36H9.42V13.92H10.98V11.36H13.54Z" />
    </SvgIcon>
  );
});
